export const ADMIN = 1
export const USER = 0
export const DRIVER = 2
export const SERVICE = 3
